<template>
  <div class="h-100 bg-white flex flex-col justify-between">
    <myc-header v-if="$route.meta && !$route.meta.hideNavbar" />
    <slot />
    <myc-footer v-if="$route.meta && !$route.meta.hideFooter" />
  </div>
</template>

<script>
import MycFooter from './containers/myc-footer.vue';
import MycHeader from './containers/myc-header.vue';

export default {
  name: 'BaseLayout',
  components: {
    MycHeader,
    MycFooter,
  },
};
</script>
